<template>
  <vue-final-modal
    v-slot="{ close }"
    esc-to-close
    name="parentMortgage"
    class="popup-promo-video"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="popup-promo-video__body" :class="additionClass">
      <div class="popup-promo-video__background">
        <picture v-if="img">
          <source
            v-for="(item, i) in img?.sources"
            :key="i"
            :srcset="item.src"
            :media="item.media"
            type="image/webp"
          />
          <img :src="img.default" loading="lazy" class="popup-base__image" />
        </picture>
        <video
          v-if="video"
          ref="video"
          :poster="video.poster"
          autoplay="autoplay"
          loop="loop"
          muted
          playsinline
          class="popup-base__video"
        >
          <source
            v-for="(item, i) in video.sources"
            :key="i"
            :type="item.type"
            :src="item.src"
            :media="item.media"
          />
        </video>
      </div>
      <div class="popup-promo-video__content">
        <div class="popup-promo-video__title h4" v-html="title" />
        <div class="popup-promo-video__desc" v-html="desc" />
        <div class="popup-promo-video__text" v-html="text" />
        <div class="popup-promo-video__button">
          <button
            v-if="isDefault"
            class="btn btn-default btn-small"
            data-popup-with-chats
            data-popup-with-chats-title="Узнать подробнее"
            data-popup-with-chats-source-id="promo-banner"
            @click="close"
          >
            Узнать подробнее
          </button>
          <button
            v-else-if="isToPlans"
            class="btn btn-default btn-small"
            @click="toPlans(close)"
          >
          Узнать подробнее
          </button>
          <button
            v-else
            class="btn btn-default btn-small"
            @click="toTour(close)"
          >
            Смотреть 3Д-тур
          </button>
        </div>
        <div v-if="additionText" class="popup-promo-video__bottom">
          <div class="popup-promo-video__additionText" v-html="additionText" />
        </div>
      </div>
      <a href="javascript:void(0)" class="vfm__close" @click="close"
        ><img src="@/assets/i/cross.svg"
      /></a>
    </div>
  </vue-final-modal>
</template>

<script>
export default {
  inject: ["mainStore"],
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    additionText: {
      type: String,
      default: "",
    },
    additionClass: {
      type: String,
      default: "",
    },
    img: {
      default: null,
    },
    video: {
      default: null,
    },
    isDefault: {
      default: false,
    },
    isToPlans: {
      default: false,
    }
  },
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    if (this.$refs.video) {
      this.$refs.video.play();
    }
  },
  methods: {
    beforeOpen(event) {
      document.querySelector(".header").classList.add("overflow");
    },
    closed() {
      document.querySelector(".header").classList.remove("overflow");
      this.mainStore.state.timerAnimation = true;
    },
    toTour(closePopup) {
      this.$vfm.show({
        component: "PopupPanorama",
        bind: {
          title: "3Д-тур",
          src: "https://biganto.ru/tour/59c7348e-67ff-4ac5-8545-a526e38eb910/",
        },
      });

      closePopup();

      this.closed();
    },
    toPlans(closePopup) {
      this.$router.push('/apartments/search/');
      closePopup();
      this.closed();

    },
  },
};
</script>
<style scoped lang="scss">

.vfm--inset {
  background-color: rgba(0, 0, 0, 0.2);
}

.popup-promo-video {
  &__body {
    background-color: #fff;
    width: 330px;
    max-width: calc(100vw - 30px);
    margin: 0 15px;
    position: relative;
  }

  &__background {
    img, video {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    &--no-mob {
      display: none;
    }
  }

  ::v-deep .vfm__content::before,
  ::v-deep .vfm__content::after {
    display: none;
  }

  &__content {
    position: relative;
    display: flex;
    height: 100%;
    flex-direction: column;
    width: 100%;
    padding: 30px 20px;
    box-sizing: border-box;
    min-height: 492px;

    @media screen and (min-width: 768px) {
      padding: 40px 20px;
    }

    @media screen and (max-width: 991px) {
      min-height: auto;
      padding: 20px 10px;
    }

    @media screen and (min-width: 991px) {
      padding: 42px 30px;
      width: 480px;
    }
  }

  &__title {
    margin-bottom: 16px;
    line-height: 40px;
    font-size: 36px;
    font-weight: 400;

    @media screen and (max-width: 500px) {
      line-height: 1.1;
    }

    @media screen and (min-width: 991px) {
      font-size: 36px;
    }
  }

  ::v-deep span {
    display: inline-block;
  }

  &__desc {
    font-size: 18px;
    margin-bottom: 24px;
    max-width: 220px;

    @media screen and (min-width: 991px) {
      margin-bottom: 24px;
      max-width: none;
    }
  }

  &__text {
    font-size: 18px;
    margin-bottom: 24px;
    max-width: 220px;

    @media screen and (min-width: 991px) {
      margin-bottom: 24px;
      max-width: none;
    }
  }

  &__additionText {
    color: #333;
    font-family: var(--font-family-2);
    font-size: 12px;
    line-height: 120%;
    margin-top: 12px;
  }

  &__button {
    margin-top: auto;
    width: 390px;
    max-width: 100%;

    @media screen and (max-width: 991px) {
      margin-top: 0;
    }

    .btn {
      width: 100%;
      height: 58px;

      @media screen and (max-width: 991px) {
        height: 48px;
      }
    }
  }

  &__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.custom-popup {
  background-color: #ed1c24;
  color: #ffffff;
}

@media screen and (min-width: 991px) {
  .popup-promo-video {
    &__body {
      width: 960px;
      min-height: 492px;
    }

    &__background {
      position: absolute;
      top: 0;
      right: 0;
      width: calc(100% - 480px);
      height: 100%;
      object-fit: cover;

      &--no-mob {
        display: block;
      }
    }
  }
}
</style>
